import Joi from 'joi';

export default Joi.object({
	income: Joi.number()
		.integer()
		.positive()
		.error(() => ({
			message: 'Vyměřovací základ musí být celé kladné číslo!',
		})),
	dismissalType: Joi.any().allow([1, 2, 3, 4, 5, 6]),
	age: Joi.number()
		.integer()
		.positive()
		.min(18)
		.error(() => ({
			message: 'Věk musí být celé kladné číslo, minimálně 18!',
		})),
});
